/**
 * React, react redux and react localization imports
 */
import DeleteForever from '@mui/icons-material/DeleteForever'
import { Box, Grid } from '@mui/material'
import { useState } from 'react'
import { Button } from './Button'
import { TranslatableTypography } from './Typography'

const style = {
  root: {
    marginTop: '16px',
    textAlign: 'center'
  },
  confirmText: {
    fontSize: '0.8rem',
    marginBottom: '8px',
    textAlign: 'center'
  },
  button: {
    minWidth: '190px'
  },
  buttonRow: {
    marginTop: '6px'
  },
  buttonWrapper: {
    textAlign: 'center'
  }
}

export const ResetApplication = () => {
  const [confirming, setConfirming] = useState(false)

  const reset = () => {
    localStorage.clear()
    window.location.reload()
  }

  return (
    <Box sx={style.root}>
      {!confirming && (
        <Button
          variant='filled'
          sx={style.button}
          onClick={() => setConfirming(true)}
          icon={<DeleteForever />}
          text='Reset application cache'
        />
      )}

      {confirming && (
        <Grid container sx={style.buttonRow}>
          <Grid item xs={12}>
            <TranslatableTypography sx={style.confirmText}>
              Are you sure you want to reset application and reload data?
            </TranslatableTypography>
          </Grid>
          <Grid item xs={6} sx={style.buttonWrapper}>
            <Button variant='filled' onClick={reset} icon={<DeleteForever />} text='Yes' />
          </Grid>
          <Grid item xs={6} sx={style.buttonWrapper}>
            <Button variant='filled' onClick={() => setConfirming(false)} text='No' />
          </Grid>
        </Grid>
      )}
    </Box>
  )
}
